<template>
  <a-modal
    title="打印机服务"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    ok-text="打印"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div>
      <p><span style="color: red">必装</span>&nbsp;&nbsp;通用打印组件 <a-button type="link" @click="downloadSetup('zj')">点击下载</a-button></p>
      <p><span style="color: #29d209">立象Argox</span>&nbsp;&nbsp;打印机驱动  <a-button type="link" @click="downloadSetup('qd')">点击下载</a-button></p>
      <p>请先确定已安装您的打印机的打印驱动 <br/>
        如果下拉窗口中没有显示您的打印机型号，请联系业务经理</p>
    </div>
    <a-select style="width: 300px" placeholder="请选择打印机" v-model="name">
      <a-select-option v-for="(item, index) in printerList" :key="index" :value="index">{{ item }}</a-select-option>
    </a-select>
    <a-form-model
      ref="form"
    >
      <a-form-model-item label="水平偏移(mm)">
        <a-input-number v-model="hor" />
      </a-form-model-item>
      <a-form-model-item label="垂直偏移(mm)">
        <a-input-number v-model="ver" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { printStart, getPrinterList } from '@/utils/print'
import { getOrderPrinterList } from '@/api/print'
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      hor: 0, // 水平偏移
      ver: 0, // 垂直偏移
      visible: false,
      confirmLoading: false,
      printerList: [], // 打印机列表
      printContent: [], // 需要打印的内容
      width: 92, // 打印页宽
      height: 35, // 打印页高
      name: 0 // 打印的序号 -1为默认打印机
    }
  },
  created() {
    var pri = Cookies.get('print_name')
    if (pri) {
      this.name = parseInt(pri)
    }
  },
  props: {
    printData: {
      type: Object,
      default: () => {
        return {
        }
      }
    }
  },
  methods: {
    showModal(id = 0) {
      this.visible = true
      this.printerList = getPrinterList()
      var pData = this.printData
      if (JSON.stringify(pData) === '{}') {
        const orderId = document.getElementById('oId').innerText.replace(/\s+/g, '')
        getOrderPrinterList({ orderId: orderId }).then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.assData(data)
          }
        })
      } else {
        this.assData(pData)
      }
    },
    assData(data) {
      const pageSize = data.size.split('*')
      this.printContent = data.unit
      this.width = pageSize[0]
      this.height = pageSize[1]
    },
    handleOk(e) {
      this.confirmLoading = true
      // data{ top：页面上边距， left：页面左边距， width：页面宽， height：页面高， list:要打印的参数， num:打印的数量， type：存在则为预览 , name：打印机序号}
      Cookies.set('print_name', this.name, { expires: 60 })
      const data = {
        top: this.ver,
        left: this.hor,
        list: this.printContent,
        width: this.width,
        height: this.height,
        name: this.name
      }
      const _this = this
      printStart(data, _this, function (__this) {
        __this.$message.success('打印任务全部下发，等待打印机打印...')
        __this.confirmLoading = false
        __this.$emit('close')
        __this.visible = false
      })
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
    downloadSetup(type) {
      var href
      switch (type) {
        case 'qd':
          href = 'https://8899-city.oss-cn-shenzhen.aliyuncs.com/soft/Argox%E7%AB%8B%E8%B1%A1%E6%89%93%E5%8D%B0%E9%A9%B1%E5%8A%A8.zip'
          break
        case 'zj':
          href = 'https://8899-city.oss-cn-shenzhen.aliyuncs.com/soft/%E6%89%93%E5%8D%B0%E7%BB%84%E4%BB%B6.zip'
          break
      }
      this.downloadFile(href)
    },
    downloadFile(url) {
      try {
        var elemIF = document.createElement('iframe')
        elemIF.src = url
        elemIF.style.display = 'none'
        document.body.appendChild(elemIF)
      } catch (e) {
        alert('下载异常！')
      }
    }
  }
}
</script>
